import React from 'react'
import { Link } from "gatsby"
import styled from '@emotion/styled';
import { mq, grayBorder } from '../../_style';
import Filter from '../../components/organisms/filter';
import PageMain from '../../components/organisms/pageMain';
import imgMain from '../../assets/imgs/lineup/img-main.jpg';
import imgMainSp from '../../assets/imgs/lineup/sp/img-main.jpg';
import { Helmet } from 'react-helmet';
const Container = styled.div`
`

const BorderBottom = styled.div`
  ${mq.pc} {
    width: 960px;
    height: 58px;
    margin: 0 auto;
    border-top: 1px solid ${grayBorder};
  }
  ${mq.sp} {
    padding-top: 50px;
    border-top: 1px solid ${grayBorder};
  }
`

const Lineup = (props) => {
  return(
    <Container>
      <Helmet
        title="ラインナップ | モンダミン | アース製薬"
        meta={[
            { name: 'description', content: 'モンダミンのラインナップについてご紹介します。口臭・むし歯予防・ホワイトニングといった効果・目的、ノンアルコールや子ども用など、気になるお口の悩みに合わせて豊富なラインナップの中からお選びいただけます。' },
            { name: 'keywords', content: 'マウスウォッシュ,洗口液,液体ハミガキ,液体歯磨き,モンダミン,もんだみん,mondahmin,口臭,口臭ケア,むし歯,歯肉炎,歯周病,歯周炎,オーラルケア,アース製薬' }
        ]}
      />
      <PageMain bg={imgMain} bgSp={imgMainSp} en={'LINE UP'}>お口の悩みに<br />選べるラインナップ</PageMain>
      <Filter history={props}></Filter>
      <BorderBottom></BorderBottom>
    </Container>
  );
}
export default Lineup
